export default __webpack_public_path__ + "static/media/lia-rozenfeld.ff1eae96.png";